import { render, staticRenderFns } from "./PlantTypeNavButton.vue?vue&type=template&id=b35b40ca&scoped=true&"
import script from "./PlantTypeNavButton.vue?vue&type=script&lang=ts&"
export * from "./PlantTypeNavButton.vue?vue&type=script&lang=ts&"
import style0 from "./PlantTypeNavButton.vue?vue&type=style&index=0&id=b35b40ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b35b40ca",
  null
  
)

export default component.exports